import { Model, type ModelProps } from '@/infra/model'
import { Id } from '@/infra/id'
import { observable } from 'mobx'

export type BundleIncludedItemProps = ModelProps<BundleIncludedItem>

export class BundleIncludedItem extends Model<BundleIncludedItem> {
  @observable accessor inventoryItemId = Id.none
  @observable accessor inventoryItemVersionId = Id.none
  @observable accessor name = ''
  @observable accessor price = 0
  @observable accessor proPrice = 0
  @observable accessor description = ''
  @observable accessor workspaceId = Id.none
  @observable accessor includedQuantity = 0
  @observable accessor isBaseItem = false
  @observable accessor archived = false
}
